import * as React from "react";

export const MarkdownView = React.lazy(() => import("./markdown-impl"));
